import {useBookingContext} from 'src/context/BookingContext';
import {useMatchMedia} from 'src/hooks/useMatchMedia';
import {BookingInitialAside} from '../Booking/BookingInitial/BookingInitialAside';
import {BookingStepIndicator} from '../Booking/BookingStepIndicator/BookingStepIndicator';
import {BookingConfirm} from '../Booking/BookingInformation/BookingConfirm';

export function LocationAside() {
    const {bookingState} = useBookingContext();

    const mediumDisplay = useMatchMedia('(max-width: 51.25rem)');

    const stepComponent = () => {
        switch (bookingState.step) {
            case 'initial':
                return <BookingInitialAside />;
            case 'confirm':
                return <BookingConfirm />;
            case 'completed':
                return <BookingConfirm />;
            default:
                return <BookingStepIndicator />;
        }
    };

    return (
        <>
            {(!mediumDisplay || bookingState.step === 'initial' || bookingState.step === 'completed') &&
                stepComponent()}
        </>
    );
}
